(function($) {

	'use strict';

	var init = function() {
		buttonClickHandler();
	};

	var buttonClickHandler = function() {
		$('.mainMenu__button').on('click', function(){
			$('.mainMenu').toggleClass('opened');
		})
	}
	
	$(document).ready(function() {
		init();
	});

})(jQuery);
